import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class Logger {
  private readonly isProduction = environment.production;

  debug(message?: unknown, ...optionalParams: unknown[]): void {
    if (this.isProduction) {
      return;
    }
    console.debug(message, ...optionalParams);
  }

  info(message?: unknown, ...optionalParams: unknown[]): void {
    if (this.isProduction) {
      return;
    }
    console.info(message, ...optionalParams);
  }

  log(message?: unknown, ...optionalParams: unknown[]): void {
    if (this.isProduction) {
      return;
    }
    console.log(message, ...optionalParams);
  }

  warn(message?: unknown, ...optionalParams: unknown[]): void {
    console.warn(message, ...optionalParams);
  }

  error(message?: unknown, ...optionalParams: unknown[]): void {
    console.error(message, ...optionalParams);
  }
}
